import { postAnalytics } from "../../../../../PatientComponents/analytics";
import Wrapper from "./Wrapper";
import LegalText from "./LegalText";
import Transition from "../Transition";
import { usePatientFacing } from "../../../../flow/patientFacing/hooks/usePatientFacing";
import GIPatientHeader from "../components/GIPatientHeader";

function GILegal() {
  const { getEventDataLocal } = usePatientFacing();
  const event = getEventDataLocal();
  const { caseId } = event?.Case?.id;

  const BackClick = () => {
    postAnalytics({ userId: caseId, type: "Legal-Back-clicked" });
  };

  return (
    <Transition>
      <GIPatientHeader />
      <Wrapper onBack={BackClick} id="LegalWrapper">
        <LegalText />
      </Wrapper>
    </Transition>
  );
}

export default GILegal;
